// VSB announcement bar: the shared countdown, rotating messages, and the
// bar's height for whatever sticks below it. See sections/vsb-announcement-bar.liquid.
if (!customElements.get('vsb-announcement-bar')) {
  // Every timer section on the store reads and writes this key, so they all
  // count down to the same moment. Do not rename it.
  const TIMER_KEY = 'exclusiveWelcome_shared_timer';
  const pad = (n) => String(n).padStart(2, '0');

  customElements.define(
    'vsb-announcement-bar',
    class VsbAnnouncementBar extends HTMLElement {
      connectedCallback() {
        this.startTimer();
        this.startMessages();
        if (this.dataset.sticky === 'true') this.publishHeight();
      }

      disconnectedCallback() {
        clearInterval(this.timerId);
        clearInterval(this.rotateId);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      /* ---------------------------------------------------------- countdown */

      startTimer() {
        this.timer = this.querySelector('[data-announcement-timer]');
        if (!this.timer) return;
        this.seconds = Number(this.dataset.timerSeconds) || 900;
        this.parts = {
          h: this.timer.querySelector('[data-timer-hours]'),
          m: this.timer.querySelector('[data-timer-minutes]'),
          s: this.timer.querySelector('[data-timer-seconds]'),
        };
        this.tick();
        this.timer.hidden = false;
        this.timerId = setInterval(() => this.tick(), 1000);
      }

      expiry() {
        let expiry = NaN;
        try {
          expiry = parseInt(localStorage.getItem(TIMER_KEY), 10);
        } catch (e) {
          expiry = this.memoryExpiry;
        }
        if (Number.isNaN(expiry) || !expiry || expiry <= Date.now()) {
          expiry = Date.now() + this.seconds * 1000;
          this.memoryExpiry = expiry;
          try {
            localStorage.setItem(TIMER_KEY, expiry);
          } catch (e) {
            /* storage blocked: this page keeps its own count */
          }
        }
        return expiry;
      }

      tick() {
        const s = Math.max(0, Math.floor((this.expiry() - Date.now()) / 1000));
        // Only the digits that changed: every change to the page is work for
        // whatever watches it (session recorders scan the page on each one).
        const set = (el, v) => { if (el.textContent !== v) el.textContent = v; };
        set(this.parts.h, pad(Math.floor(s / 3600)));
        set(this.parts.m, pad(Math.floor((s % 3600) / 60)));
        set(this.parts.s, pad(s % 60));
      }

      /* ----------------------------------------------------------- messages */

      startMessages() {
        this.box = this.querySelector('.vsb-bar__messages');
        this.messages = this.box ? [...this.box.querySelectorAll('.vsb-bar__message')] : [];
        if (this.messages.length < 2) return;
        this.index = 0;
        this.paused = false;

        const next = this.querySelector('[data-next]');
        if (next) next.addEventListener('click', () => this.show(this.index + 1));

        ['mouseenter', 'focusin'].forEach((e) => this.addEventListener(e, () => (this.paused = true)));
        this.addEventListener('mouseleave', () => (this.paused = false));
        this.addEventListener('focusout', (e) => !this.contains(e.relatedTarget) && (this.paused = false));

        if (this.box.dataset.autoplay === 'true') {
          const ms = (Number(this.box.dataset.speed) || 5) * 1000;
          this.rotateId = setInterval(() => !this.paused && this.show(this.index + 1), ms);
        }

        // Theme editor: selecting a message shows it and holds it there.
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.messages.findIndex((m) => m.dataset.block === e.detail.blockId);
          if (i < 0) return;
          this.paused = true;
          this.show(i);
        });
        document.addEventListener('shopify:block:deselect', () => (this.paused = false));
      }

      show(i) {
        this.messages[this.index].hidden = true;
        this.index = (i + this.messages.length) % this.messages.length;
        this.messages[this.index].hidden = false;
      }

      /* ------------------------------------------------------------- height */

      publishHeight() {
        const set = () => document.documentElement.style.setProperty('--pdp-bar-h', `${this.offsetHeight}px`);
        set();
        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(set);
          this.resizeObserver.observe(this);
        } else {
          window.addEventListener('resize', set);
        }
      }
    }
  );
}
